.content {
  overflow: scroll;
}

.navIcon path {
  fill: var(--icon-button-normal-variant-secondary-rank-normal-state-icon-color);
}
